(function () {
  'use strict';
  function parseTarget(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+01:00$/.test(value)) return NaN;
    const timestamp = Date.parse(value);
    if (!Number.isFinite(timestamp)) return NaN;
    const back = new Date(timestamp + 3600000).toISOString().slice(0, 19) + '+01:00';
    return back === value ? timestamp : NaN;
  }
  function getRemaining(target, now) {
    if (!Number.isFinite(target) || !Number.isFinite(now)) return null;
    const total = Math.max(0, Math.ceil((target - now) / 1000));
    return { total, days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60, expired: now >= target };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { parseTarget, getRemaining };
  if (typeof window === 'undefined' || !window.customElements || window.customElements.get('nc-shadow-countdown')) return;
  class ShadowCountdown extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.fitViewport();
      this.lastStatus = null;
      this.nodes = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(key => [key, this.querySelector('[data-' + key + ']')]));
      this.status = this.querySelector('[data-status]');
      try {
        this.events = JSON.parse(this.querySelector('[data-events]').textContent);
        if (!Array.isArray(this.events) || this.events.length !== 1 || this.events.some(event => !Number.isFinite(parseTarget(event.target)))) throw new Error('Invalid date');
      } catch (_) {
        this.dataset.state = 'error';
        this.status.textContent = this.dataset.errorText || 'Countdown unavailable. Please check the announced date.';
        return;
      }
      this.initSnow();
      const options = { signal: this.controller.signal };
      document.addEventListener('visibilitychange', () => {
        window.clearTimeout(this.timeout);
        this.syncSnow();
        if (!document.hidden) this.refresh();
      }, options);
      this.refresh();
    }
    initSnow() {
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.syncSnow = () => {
        this.dataset.snow = !this.isConnected || document.hidden || this.motionPreference.matches ? 'paused' : 'running';
      };
      this.motionPreference.addEventListener('change', this.syncSnow, { signal: this.controller.signal });
      this.syncSnow();
    }
    fitViewport() {
      this.syncViewport = () => {
        const viewport = window.visualViewport;
        const layoutHeight = Math.max(1, Math.floor(window.innerHeight || document.documentElement.clientHeight || (viewport && viewport.height) || 1));
        const height = layoutHeight;
        const bar = document.getElementById('PBarNextFrameWrapper');
        let reserved = 0;
        if (this.observedBar && this.observedBar !== bar) {
          this.viewportResizeObserver.unobserve(this.observedBar);
          this.observedBar = null;
        }
        if (bar) {
          const rect = bar.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0 && rect.height < height / 3 && rect.bottom >= height - 2) reserved = Math.max(0, Math.min(height, rect.bottom) - Math.max(0, rect.top));
          if (this.observedBar !== bar) {
            this.observedBar = bar;
            this.viewportResizeObserver.observe(bar);
          }
        }
        const available = Math.max(1, Math.floor(height - reserved));
        const value = available + 'px';
        if (this.style.getPropertyValue('--nc-viewport-height') !== value) {
          this.style.setProperty('--nc-viewport-height', value);
          this.style.setProperty('--nc-vh', available / 100 + 'px');
        }
        this.dataset.density = available < 520 ? 'tight' : available < 600 ? 'compact' : 'comfortable';
        this.dataset.fit = 'screen';
      };
      this.viewportResizeObserver = new ResizeObserver(this.syncViewport);
      this.viewportMutationObserver = new MutationObserver(this.syncViewport);
      this.viewportMutationObserver.observe(document.body, { childList:true });
      this.viewportResizeObserver.observe(document.documentElement);
      const options = { signal:this.controller.signal };
      window.addEventListener('resize', this.syncViewport, options);
      window.addEventListener('pageshow', this.syncViewport, options);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.syncViewport, options);
        window.visualViewport.addEventListener('scroll', this.syncViewport, options);
      }
      this.syncViewport();
    }
    refresh() {
      window.clearTimeout(this.timeout);
      if (!this.isConnected || !this.events) return;
      const event = this.events[0];
      const remaining = getRemaining(parseTarget(event.target), Date.now());
      Object.keys(this.nodes).forEach(key => { this.nodes[key].textContent = String(remaining[key]).padStart(2, '0'); });
      this.dataset.state = remaining.expired ? 'expired' : 'counting';
      this.querySelector('[data-countdown-label]').textContent = remaining.expired ? (this.dataset.endedLabel || 'Countdown ended') : (this.dataset.beforeLabel || 'Wave 2 coming in');
      const newStatus = remaining.expired ? (this.dataset.endedText || 'Countdown ended. Await the official release update.') : '';
      if (newStatus !== this.lastStatus) { this.status.textContent = newStatus; this.lastStatus = newStatus; }
      if (!remaining.expired && !document.hidden) this.timeout = window.setTimeout(() => this.refresh(), 1000 - (Date.now() % 1000));
    }
    disconnectedCallback() {
      window.clearTimeout(this.timeout);
      if (this.controller) this.controller.abort();
      if (this.viewportResizeObserver) this.viewportResizeObserver.disconnect();
      if (this.viewportMutationObserver) this.viewportMutationObserver.disconnect();
      this.dataset.snow = 'paused';
      this.observedBar = null;
      this.controller = null;
    }
  }
  window.customElements.define('nc-shadow-countdown', ShadowCountdown);
})();


